import React, { ReactElement } from 'react';
import { Button, Col, Row, Table } from 'react-bootstrap';
import { Courriel } from '../../../../../../common/src/entities/courriel.entity';
import AffichageChargement from '../../Utils/AffichageChargement';
import { useGetQuery } from '../../../../Utils/api';
import RichTextEditor from '../../../Common/RichTextEditor';
import TooltipSimple from '../../../Common/TooltipSimple';
import { BiLink } from 'react-icons/bi';

const userStyle: React.CSSProperties = {
    color: '#6495ED',
};

const dateOptions: Intl.DateTimeFormatOptions = {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
};

export default function HistoriqueCourrielsEntente({ idEntente }: { idEntente: number }): ReactElement {
    const courrielsQuery = useGetQuery<Courriel[]>(['ententes', idEntente, 'courriels']);

    return (
        <AffichageChargement query={courrielsQuery}>
            {function InnerCourriels({ data: courriels }) {
                return courriels.length !== 0 ? (
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>Date et heure</th>
                                <th>Expéditeur</th>
                                <th>Destinataires</th>
                                <th>Détails</th>
                            </tr>
                        </thead>
                        <tbody>
                            {courriels.map((courriel, index) => (
                                <tr key={index}>
                                    <td>{new Date(courriel.dateEnvoi).toLocaleDateString('en-CA', dateOptions)}</td>
                                    <td>
                                        <TooltipSimple
                                            texte={
                                                courriel.expediteur?.name ||
                                                'Notification Automatique noreply@solutionanimation.com'
                                            }
                                        >
                                            <span style={userStyle}>
                                                {courriel.expediteur?.name ||
                                                    'Notification Automatique noreply@solutionanimation.com'}
                                            </span>
                                        </TooltipSimple>
                                    </td>
                                    <td>
                                        <ul>
                                            {courriel.destinataires?.split(',').map((email, idx) => (
                                                <li key={idx}>{email.trim()}</li>
                                            ))}
                                        </ul>
                                    </td>
                                    <td>
                                        <strong>Objet:</strong> {courriel.title}
                                        <br />
                                        <div>
                                            <strong>Corps:</strong>
                                            <RichTextEditor value={courriel.body} readOnly={true} />
                                        </div>
                                        {courriel.documents && courriel.documents.length > 0 && (
                                            <div>
                                                <strong>Documents attachés:</strong>
                                                {courriel.documents.map((doc, idx) => (
                                                    <Col className="d-flex align-items-center" key={idx}>
                                                        <a
                                                            href={doc.url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-muted"
                                                        >
                                                            <Button variant="link" size="sm">
                                                                <BiLink size="1.5em" />
                                                            </Button>
                                                        </a>
                                                        <span>{doc.name}</span>
                                                    </Col>
                                                ))}
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <Row>
                        <Col>Aucun courriel n'est associé à cette entente</Col>
                    </Row>
                );
            }}
        </AffichageChargement>
    );
}
